import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  orderBy,
  query,
  serverTimestamp,
  updateDoc,
} from "firebase/firestore";
import { deleteObject, ref } from "firebase/storage";
import { database, storage } from "../../lib/cliente";
import { AtividadesService } from "../atividades";
import { Pacote } from "../../types";
import { enqueueSnackbar } from "notistack";

const PacotesCollection = collection(database, "pacotes");

export class PacoteServiceClass {
  private static _instance: PacoteServiceClass;

  static getInstance(): PacoteServiceClass {
    if (!this._instance) {
      this._instance = new PacoteServiceClass();
    }

    return this._instance;
  }

  async addPacote(data: Pacote) {
    try {
      const docRef = await addDoc(PacotesCollection, {
        ...data,
        createdAt: serverTimestamp(),
      });

      await updateDoc(docRef, {
        id: docRef.id,
      });

      await AtividadesService.addAtividade(
        `Adicionou um novo pacote: ${data.title}`
      );
      enqueueSnackbar("Pacote adicionado com sucesso!", { variant: "success" });
    } catch (err) {
      console.log(err);
      enqueueSnackbar("Algo deu errado! Tente novamente", { variant: "error" });
    }
  }

  async getPacotes(): Promise<Pacote[] | undefined> {
    const pacotesQuery = query(PacotesCollection, orderBy("createdAt", "desc"));
    const pacotes = await getDocs(pacotesQuery);

    return pacotes.docs.map((item) => ({
      ...item.data(),
    })) as Pacote[];
  }

  async getPacote(id: string): Promise<Pacote | undefined> {
    const docRef = doc(PacotesCollection, id);

    try {
      const res = await getDoc(docRef);

      return res.data() as Pacote;
    } catch (err) {
      console.log(err);
    }
  }

  async deleteImages(data: string[]) {
    try {
      await Promise.all(
        data.map(async (imageUrl) => {
          // Extrair o nome do arquivo a partir da URL (opcional, dependendo da sua estrutura de armazenamento)
          const fileName = extractFileNameFromUrl(imageUrl);
          const fileRef = ref(storage, `images/${fileName}`);

          await deleteObject(fileRef);
        })
      );
    } catch (err) {
      console.log("Error:", err);
    }
  }

  async deletePacote(data: Pacote) {
    try {
      const docRef = doc(PacotesCollection, data.id);

      await Promise.all(
        data.imagesUrl.map(async (imageUrl) => {
          // Extrair o nome do arquivo a partir da URL (opcional, dependendo da sua estrutura de armazenamento)
          const fileName = extractFileNameFromUrl(imageUrl);
          const fileRef = ref(storage, `images/${fileName}`);

          await deleteObject(fileRef);
        })
      );
      await deleteDoc(docRef);

      await AtividadesService.addAtividade(`Deletou um pacote: ${data.title}`);
      enqueueSnackbar("Pacote deletado com sucesso!", { variant: "success" });
    } catch (err) {
      console.log("Error:", err);

      enqueueSnackbar("Algo deu errado! Tente novamente", { variant: "error" });
    }
  }

  async updatePacote(data: Pacote) {
    try {
      const docRef = doc(PacotesCollection, data.id);

      await AtividadesService.addAtividade(`Atualizou o pacote: ${data.title}`);

      await updateDoc(docRef, {
        ...data,
      });
      enqueueSnackbar("Pacote atualizado com sucesso!", {
        variant: "success",
      });
    } catch (err) {
      console.log(err);
      enqueueSnackbar("Algo deu errado! Tente novamente", {
        variant: "error",
      });
    }
  }
}

const extractFileNameFromUrl = (url: string) => {
  const regex = /%2F(.+?)\?/;
  const match = url.match(regex);
  if (match && match[1]) {
    const fileNameWithSpaces = decodeURIComponent(match[1].replace(/\+/g, " "));
    return fileNameWithSpaces;
  }
  return null;
};

export const PacoteService = PacoteServiceClass.getInstance();
